export const projects = [
  {
    id: 99,
    title: 'Hiweb ID - Hệ Thống ERP Đẳng Cấp Enterprise',
    description: 'Siêu dự án ERP quản trị doanh nghiệp tổng thể. Tích hợp SSO (Single Sign-On), quản lý tài nguyên tập trung, phân quyền chi tiết (RBAC) và tự động hóa quy trình nghiệp vụ phức tạp. Hệ thống xử lý hàng triệu request với độ trễ thấp.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80',
    technologies: ['Microservices', 'Docker', 'Kubernetes', 'CI/CD', 'Redis', 'React'],
    category: 'Hệ Thống Phức Tạp',
    github: '#',
    live: 'https://id.hiweb.vn/',
    featured: true,
    color: 'from-cyan-500 to-blue-700'
  },
  {
    id: 1,
    title: 'Beauty Store - Thiên Đường Mỹ Phẩm',
    description: 'Cửa hàng mỹ phẩm trực tuyến chuyên nghiệp. Tích hợp giỏ hàng, thanh toán và quản lý sản phẩm. Giao diện sang trọng, nữ tính, tối ưu trải nghiệm mua sắm.',
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdd403348?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80',
    technologies: ['React', 'Redux', 'Tailwind CSS', 'Node.js', 'Payment Gateway'],
    category: 'Thương Mại Điện Tử',
    github: 'https://github.com/hole-six',
    live: 'https://beauty-storevn.netlify.app/',
    featured: true,
    color: 'from-pink-400 to-rose-600'
  },
  {
    id: 2,
    title: 'WaveStore - Hệ Thống Bán Hàng Hiện Đại',
    description: 'Nền tảng thương mại điện tử mạnh mẽ với hơn 15 logic quản lý bán hàng phức tạp. Hệ thống quản lý kho, vận chuyển, và xử lý đơn hàng tự động hóa cao.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80',
    technologies: ['PHP', 'Laravel', 'MySQL', 'Vue.js', 'System Architecture'],
    category: 'Hệ Thống Phức Tạp',
    github: 'https://github.com/hole-six',
    live: 'http://wavestore.id.vn/',
    featured: true,
    color: 'from-blue-400 to-blue-600'
  },
  {
    id: 3,
    title: 'Website Giá Rẻ - Kho Giao Diện Đa Sắc Màu',
    description: 'Nền tảng cung cấp và giới thiệu hàng trăm mẫu giao diện website đẹp mắt. Cho phép khách hàng xem trước, lựa chọn và tùy biến màu sắc theo nhu cầu.',
    image: 'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80',
    technologies: ['React', 'Next.js', 'Tailwind CSS', 'Framer Motion'],
    category: 'Web App',
    github: 'https://github.com/hole-six',
    live: 'https://websitegiare.netlify.app/',
    featured: true,
    color: 'from-violet-400 to-purple-600'
  },
  {
    id: 4,
    title: 'Rượu Jagermeister Vũng Tàu - Landing Page Bán Rượu',
    description: 'Landing page bán rượu chuyên nghiệp với thiết kế nhanh gọn, responsive hoàn hảo trên mọi thiết bị. Tích hợp đầy đủ chức năng giỏ hàng, thanh toán và quản lý đơn hàng. Giao diện tối ưu cho trải nghiệm mua sắm nhanh chóng.',
    image: 'https://images.unsplash.com/photo-1569529465841-dfecdab7503b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80',
    technologies: ['React', 'Node.js', 'Express', 'MongoDB', 'Responsive Design', 'Payment Integration'],
    category: 'Landing Page',
    github: 'https://github.com/hole-six',
    live: 'https://ruoujagermaistervungtau.onrender.com/',
    featured: true,
    color: 'from-amber-500 to-orange-700'
  }
];

export const categories = [
  'Tất Cả',
  'Thương Mại Điện Tử',
  'Web App',
  'Giáo Dục',
  'ERP System',
  'Landing Page'
];
